// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StateSequenceDrawerParent {\n  position: absolute;\n  right: 0px;\n  top: 100px; }\n\n.StateSequenceDrawerPaper {\n  min-width: 200px;\n  max-width: 300px; }\n", ""]);
// Exports
module.exports = exports;
